export const updateShopFilterUrlSearchParams = (data) => {
  if (typeof history !== 'undefined' && typeof window !== 'undefined') {
    const hasFilter = Object.keys(data).length > 0;

    // NO Current filter -> Delete all search params if no shop filters
    if (!hasFilter && window.location.search === '') {
      // Get current URL
      const url = new URL(window.location.href);
      // Iterate through search params
      for (const key of url.searchParams.keys()) {
        // delete
        url.searchParams.delete(key);
      }
      history.replaceState({}, '', url.href);
    } else {
      // HAS filters
      // Remove anchor id from url
      const href = window.location.href.split('#');
      const url = new URL(href[0]);
      // const filters =
      // Check if form has active filters
      Object.keys(data).forEach((filterInput) => {
        // multiple filters list
        if (
          data[filterInput] &&
          typeof data[filterInput] === 'object' &&
          data[filterInput].length > 0
        ) {
          url.searchParams.delete(filterInput);
          data[filterInput].forEach((filter) => {
            url.searchParams.append(filterInput, filter);
          });
        } else if (typeof data[filterInput] === 'string') {
          // simple filters list
          url.searchParams.delete(filterInput);
          url.searchParams.append(filterInput, data[filterInput]);
        } else {
          url.searchParams.delete(filterInput);
        }
      });

      history.replaceState({}, '', url.href);
    }
  }
};

export const returnFiltersActive = (data) => {
  let isActive = false;
  // Check if form has active filters
  Object.keys(data).forEach((filterInput) => {
    if (data[filterInput].length > 0) {
      isActive = true;
    }
  });

  return isActive;
};

export const handleFilterScrollReset = () => {
  // Reset scroll on filter change
  if (typeof window !== 'undefined') {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
};
